module.exports = __webpack_public_path__ + "static/media/machine_learning_dark.bceb5d97.svg";